import React from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';
import LocationMarker, {
    ALIGNMENT
} from 'common/components/core/markers/LocationMarker';
import { dashboardColors } from 'common/enums/ColorEnum';

import theme from './PolylineMarker.scss';

class PolylineMarker extends React.PureComponent {
    render() {
        const { markerIcon, theme, sideLength, className } = this.props;
        return (
            <LocationMarker
                sideLength={sideLength}
                markerIcon={markerIcon}
                theme={theme}
                color={dashboardColors.salmon.name}
                withArrow={false}
                className={classnames(theme.polylineMarker, className)}
                markerAlignment={ALIGNMENT.Center}
            />
        );
    }
}
PolylineMarker.defaultProps = {
    sideLength: 10
};
const ThemedPolylineMarker = themr('PolylineMarker', theme)(PolylineMarker);
export default ThemedPolylineMarker;
export { ThemedPolylineMarker as PolylineMarker };
